import { type TReduxState } from '@/packages/redux-state/store';

export const rootStateBranchSelector =
  <ReduxStateBranchName extends keyof TReduxState>(rootStateBranchName: ReduxStateBranchName) =>
  (state: TReduxState): TReduxState[ReduxStateBranchName] =>
    state[rootStateBranchName];
